import { render, staticRenderFns } from "./CaixaPages.vue?vue&type=template&id=0ad0600e&"
import script from "./CaixaPages.vue?vue&type=script&lang=js&"
export * from "./CaixaPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports